import React from "react";
import {
  Navigate,
} from "react-router-dom";


const StoreListComponent = React.lazy(() => import("../../../components/store/components/list/page"));


export const almacenRoutes = [
  {
    path: 'list',
    element: <StoreListComponent />,
  },
  
  {
    path: '',
    element: <Navigate replace to="/almacen/list" />
  },
]